<template>
  <el-dialog title='补班日' :visible='dialogVisible' @close='handleCloseWorkingDialog' label-position='left' top='4vh'>
      <el-form size='mini'>
        <el-form-item style="margin-top: 20px">
          <!--表头-->
          <el-form-item style='float: left;margin-bottom: 5px;width:100%'>
            <el-row :gutter='20' style='text-align: left;font-weight: bold'>
              <el-col :span='15'><span>日期</span></el-col>
              <el-col :span='3'><span>操作</span></el-col>
            </el-row>
          </el-form-item>
          <!--参数-->
          <el-form-item v-for='(item, i) in workings' :key='i' style='float: left;margin-bottom: 5px;width:100%'>
            <el-row :gutter='20'>
              <el-col :span='15'><el-input v-model="item.label" placeholder='日期'></el-input></el-col>
              <el-col :span='3'><el-button type='info' size='mini' circle icon="el-icon-delete" @click='handleDeleteParams(item)'> </el-button></el-col>
            </el-row>
          </el-form-item>
          <el-form-item v-if="formatJson">
            <el-input type="textarea" placeholder="请输入内容" v-model="textarea"> </el-input>
            <el-button type='primary' size='mini' @click='handleFormatJson'>自动转换</el-button>
          </el-form-item>
          <el-form-item style='float: left'>
            <el-button type='primary' size='mini' @click='handleAddParams'>添加单行</el-button>
            <el-button type='primary' size='mini' @click='handleAddTextarea'>粘贴文本</el-button>
          </el-form-item>
        </el-form-item>
      </el-form>
    <div slot='footer' class='dialog-footer' style='text-align: left'>
      <el-button type='primary' @click='handleSaveDialog'>保 存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import api from '@/api/channel'

export default {
  name: 'workingDialog',
  props: {
    dialogVisible: Boolean,
    holidayData: Object
  },
  computed: {
    appId () {
      return this.$store.getters.appId
    }
  },
  watch: {
    holidayData: function (val) {
      if (val.working != null) {
        const arr = JSON.parse(val.working)
        const objs = []
        const list = [...arr]
        list.forEach(function (item, index) {
          objs.push(
            { id: index + 1, label: item }
          )
        })
        this.workings = Object.assign([], objs)
      } else {
        const objs = []
        this.workings = Object.assign([], objs)
      }
    }
  },
  data () {
    return {
      workings: [],
      textarea: '',
      formatJson: false
    }
  },
  methods: {
    // 添加参数
    handleAddParams () {
      const params = { }
      if (!this.workings) {
        this.workings = []
      }
      this.workings.push(params)
    },
    // 删除参数
    handleDeleteParams (i) {
      this.workings.splice(i, 1)
    },
    // 保存
    handleSaveDialog () {
      // 将空的参数删掉
      const params = {}
      if (this.workings) {
        let len = this.workings.length
        const arr = [...this.workings]
        while (len--) {
          if (arr[len].id === '') {
            arr.splice(len, 1)
          }
        }
        params.working = arr
      }
      params.working = params.working && params.working.length > 0 ? JSON.stringify(params.working) : null
      const list = JSON.parse(params.working)
      const objs = []
      list.forEach(function (item, index) {
        objs.push(item.label.toString())
      })
      params.working = JSON.stringify(Array.from(objs))
      params.holiday = this.holidayData.holiday
      params.year = this.holidayData.year
      params.id = this.holidayData.id
      // 保存补班日列表
      api.updateHoliday(params).then(res => {
        this.$message.success('保存成功')
        this.$emit('handleSaveWorkingDialog', false)
      })
    },
    // 关闭模态框
    handleCloseWorkingDialog () {
      this.$emit('handleCloseWorkingDialog', false)
    },
    // 打开文本输入
    handleAddTextarea () {
      this.formatJson = !this.formatJson
    },
    // 格式转换
    handleFormatJson () {
      if (!this.textarea) {
        return this.$message.info('请输入内容')
      }
      if (typeof this.textarea !== 'string') {
        return this.$message.info('请输入字符串类型')
      }
      if (this.isJsonArray(this.textarea)) {
        const arr = JSON.parse(this.textarea)
        const objs = []
        if (arr.length > 0) {
          const list = [...arr]
          list.forEach(function (item, index) {
            objs.push(
              { id: index + 1, label: item }
            )
          })
        }
        this.workings = Object.assign([], objs)
      } else {
        return this.$message.info('请输入正确格式')
      }
    },
    isJsonArray (str) {
      try {
        if (typeof JSON.parse(str) === 'object') {
          return true
        }
      } catch (e) {
      }
      return false
    }
  }

}
</script>

<style scoped>

</style>
